<template>
  <div>
    <span
      v-tooltip.right="{content: $t('ct-card-site-edit-config'), class: 'ba-tooltip-custom'}"
      class="title-principal"
      @click.prevent="goToSettings"
    >{{ config.title.length > 40 ? config.title.substring(0, 35) + '...' : config.title }}</span>

    <span class="last-edited">
      {{ $t('ct-last-edited') }}: {{ lastEdited }}
    </span>

    <span
      v-if="isUnpublish"
      class="url-access-website"
    >{{ accessWebsiteUrl }}</span>
    <span
      v-tooltip.right="{content: $t('ct-acess-website'), class: 'ba-tooltip-custom'}"
      v-else
      :class="{'is-published': !isUnpublish}"
      class="url-access-website"
      @click.prevent="goToWebsite(config)"
    >
      <span>{{ accessWebsiteUrl }}</span>
      <builderall-icon code='6adb'></builderall-icon>
    </span>
  </div>
</template>

<script>
import moment from 'moment/moment';

export default {
  name: "WebsiteInfo",
  props: ['website_type', 'isUnpublish', 'config'],
  computed: {
    accessWebsiteUrl() {
      let accessUrl = this.config.dominio ? (this.config.domain_unicode || this.config.dominio) : this.config.url;
      return accessUrl.length > 40 ? accessUrl.substring(0, 35) + '...' : accessUrl;
    },
    lastEdited() {
      let locale = window.navigator.userLanguage || window.navigator.language;
      moment.locale(locale);
      return moment(this.config.updated_at).format('L');
    }
  },
  methods: {
    goToWebsite(config) {
      if (config.status !== 'active')
        return;

      window.open('https://' + (config.access_url || config.dominio), '_blank');
    },
    goToSettings() {
      if(this.website_type === 'mirror')
        return;

      this.$router.push({
        name: 'GeneralSettings',
        params: { id: this.config.encrypted_id }
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/websites/WebsiteInfo.vue